export default {
    header: 'Mis Plantillas Pendientes',
    navLink: '/app/checklists/pending',
    children: []
  }
  